"use strict";

($dt => {
	
	$dt.blocks['event-calendar'] = {
		
		/**
		 * This is called for each block matching this type
		 * @param {HTMLElement} container 
		 */
		LoadBlock: container => {
			$dt.Calendar.Init(container);

			const [ filter, cal_search, btn_search, btn_reset ] = [
				container.querySelector('.cal-filter'),
				container.querySelector('.calendar-search-col'),
				container.querySelector('.btn-event-search'),
				container.querySelector('.btn-event-reset')
			];

			filter.addEventListener('click', () => {
				cal_search.classList.add('active');
			});

			btn_search.addEventListener('click', () => {
				cal_search.classList.remove('active');
			});

			btn_reset.addEventListener('click', () => {
				cal_search.classList.remove('active');
			});
		}
		
	};
	
})(window.d3_wp_themejs);
